import type { SearchQuery, SearchState } from '../../appstate';
export const extractSearchState = (
    searchState: SearchState,
    currentQuery: SearchQuery
): {
    searchStateHasResults: boolean;
    searchSuggestionsHasResults: boolean;
    backendResults: string[];
} => {
    if (
        !currentQuery ||
        (searchState.searchResults &&
            searchState.searchResults.hasOwnProperty(currentQuery.queryText) &&
            searchState.searchResults[currentQuery.queryText].isError)
    ) {
        return {
            searchStateHasResults: false,
            searchSuggestionsHasResults: false,
            backendResults: undefined,
        };
    }

    const searchStateHasResults =
        searchState.searchResults &&
        searchState.searchResults.hasOwnProperty(currentQuery.queryText) &&
        !searchState.searchResults[currentQuery.queryText].isLoading;

    const searchSuggestionsHasResults =
        searchState.recipientCacheSuggestions &&
        searchState.recipientCacheSuggestions.hasOwnProperty(currentQuery.queryText);

    const backendResults =
        searchStateHasResults && searchSuggestionsHasResults
            ? searchState.recipientCacheSuggestions[currentQuery.queryText].concat(
                  Object.keys(searchState.searchResults[currentQuery.queryText].personaEmailMap)
              )
            : searchSuggestionsHasResults
            ? searchState.recipientCacheSuggestions[currentQuery.queryText]
            : undefined;

    return { searchStateHasResults, searchSuggestionsHasResults, backendResults };
};
